import React, { useMemo, useCallback } from "react";
import { createEditor } from "slate";
import { Slate, Editable, withReact } from "slate-react";
import { Leaf } from "../RichTextField";
import Element from "./Element";

const RenderText = ({ initialValue }) => {
  const editor = useMemo(() => withReact(createEditor()), []);
  const renderLeaf = useCallback((props) => <Leaf {...props} />, []);
  const renderElement = useCallback((props) => <Element {...props} />, []);
  return (
    <div>
      <Slate editor={editor} value={initialValue}>
        <Editable
          readOnly
          renderLeaf={renderLeaf}
          renderElement={renderElement}
        />
      </Slate>
    </div>
  );
};

export default RenderText;
